import { theme } from '@arc/frontend/ui-theme';
import { ms } from '@arc/shared/util-js';
import { createToast } from './create-toast';
import { joinNodes } from './join-nodes';
export function createCancelToast(message) {
  return createToast(({
    t
  }) => <>{t('toast.canceled')}</>, message, 'cancel', {
    style: {
      color: theme.colors.text.primary,
      backgroundColor: theme.colors.toasts.cancel
    }
  });
}
export function createErrorToast(message, {
  errorCodes,
  autoClose = 20 * ms.seconds,
  style,
  ...otherOptions
} = {}) {
  return createToast(({
    t
  }) => <>
				{t('toast.error')}
				{errorCodes && errorCodes.length > 0 ? <>
						:{' '}
						{joinNodes(errorCodes.map((errorCode, index) => <code key={index}>{errorCode}</code>), ', ')}
					</> : null}
			</>, message, 'error', {
    ...otherOptions,
    autoClose,
    style: {
      color: theme.colors.palettes.primary.contrastText,
      backgroundColor: theme.colors.toasts.error,
      ...style
    }
  });
}
export function createAuthErrorToast(title, message) {
  return createToast(() => title, message, 'error', {
    autoClose: 20 * ms.seconds,
    style: {
      color: theme.colors.palettes.primary.contrastText,
      backgroundColor: theme.colors.toasts.error
    }
  });
}
export function createSuccessToast(message, seconds = 3) {
  return createToast(({
    t
  }) => <>{t('toast.success')}</>, message, 'success', {
    style: {
      color: theme.colors.palettes.primary.contrastText,
      backgroundColor: theme.colors.toasts.success
    },
    autoClose: seconds * ms.seconds
  });
}
export function createArchivedToast(message) {
  return createToast(({
    t
  }) => <>{t('toast.success')}</>, message, 'success', {
    style: {
      color: theme.colors.text.primary,
      backgroundColor: theme.colors.toasts.archive
    }
  });
}
export function createWarningToast(message) {
  return createToast(({
    t
  }) => <>{t('toast.warning')}</>, message, 'warning', {
    style: {
      color: theme.colors.text.primary,
      backgroundColor: theme.colors.toasts.warning
    }
  });
}
export function createDraftToast() {
  return createToast(({
    t
  }) => <>{t('toast.draft')}</>, null, 'warning', {
    style: {
      color: theme.colors.text.primary,
      backgroundColor: theme.colors.toasts.draft
    }
  });
}